function motorfind() {

//Get values of each dropdown box
var e = document.getElementById("hp");
var strHorsepower = e.options[e.selectedIndex].value;

var e = document.getElementById("rpm");
var strRPM = e.options[e.selectedIndex].value;

var e = document.getElementById("frame");
var strFrame = e.options[e.selectedIndex].value;

var e = document.getElementById("voltage");
var strVoltage = e.options[e.selectedIndex].value;
  
var e = document.getElementById("enclosure");
var strEnclosure = e.options[e.selectedIndex].value;
  
//Build a search URL based on input
  switch(strHorsepower) {
    case "blank":
        var strHpterm = "";  
      	break;     
    case "1/2":
    	var strHpterm = "+\"1/2hp\"+OR+\"1/2 hp\"+-\"7-1/2 hp\"+-\"7-1/2hp\"+-\"5-1/2 hp\"+-\"5-1/2 hp\"+-\"1-1/2 hp\"+-\"1-1/2hp\"";
        break;  
    case "2":
        var strHpterm = "+\"" + strHorsepower + "hp\"+OR+\"" + strHorsepower + " hp\" +-\"1/2hp\"+-\"1/2 hp\"" ;  
      	break;   
    case "3":
        var strHpterm = "+\"" + strHorsepower + "hp\"+OR+\"" + strHorsepower + " hp\" +-\"1/3hp\"+-\"1/3 hp\"" ;  
      	break;     
    case "4":
        var strHpterm = "+\"" + strHorsepower + "hp\"+OR+\"" + strHorsepower + " hp\" +-\"1/4hp\"+-\"1/4 hp\"+-\"3/4hp\"+-\"3/4 hp\"" ;  
      	break;
    case "10":
        var strHpterm = "+\"" + strHorsepower + "hp\"+OR+\"" + strHorsepower + "*hp\" +-\"20 hp\"+-\"60*hp\"+-\"50*hp\"+-\"15*hp\"+-\"7.5*hp\"+-\"30 hp\"+-\"20hp\"+-\"30hp\"+-\"1/10*hp\"" ;  
        break;
    default:
        var strHpterm = "+\"" + strHorsepower + "hp\"+OR+\"" + strHorsepower + " hp\"";
      	break;      
  }  
  
  switch(strRPM) {
    case "blank": var strRPMterm = ""; break;    
    case "700-900": var strRPMterm = "+\"700*RPM\"+OR+\"705*RPM\"+OR+\"710*RPM\"+OR+\"715*RPM\"+OR+\"720*RPM\"+OR+\"725*RPM\"+OR+\"730*RPM\"+OR+\"735*RPM\"+OR+\"740*RPM\"+OR+\"745*RPM\"+OR+\"750*RPM\"+OR+\"755*RPM\"+OR+\"760*RPM\"+OR+\"765*RPM\"+OR+\"770*RPM\"+OR+\"775*RPM\"+OR+\"780*RPM\"+OR+\"785*RPM\"+OR+\"790*RPM\"+OR+\"795*RPM\"+OR+\"800*RPM\"+OR+\"805*RPM\"+OR+\"810*RPM\"+OR+\"815*RPM\"+OR+\"820*RPM\"+OR+\"825*RPM\"+OR+\"830*RPM\"+OR+\"835*RPM\"+OR+\"840*RPM\"+OR+\"845*RPM\"+OR+\"850*RPM\"+OR+\"855*RPM\"+OR+\"860*RPM\"+OR+\"865*RPM\"+OR+\"870*RPM\"+OR+\"875*RPM\"+OR+\"880*RPM\"+OR+\"885*RPM\"+OR+\"890*RPM\"+OR+\"895*RPM\"+OR+\"900*RPM\"";break;
	case "901-1200": var strRPMterm = "+\"905*RPM\"+OR+\"910*RPM\"+OR+\"915*RPM\"+OR+\"920*RPM\"+OR+\"925*RPM\"+OR+\"930*RPM\"+OR+\"935*RPM\"+OR+\"940*RPM\"+OR+\"945*RPM\"+OR+\"950*RPM\"+OR+\"955*RPM\"+OR+\"960*RPM\"+OR+\"965*RPM\"+OR+\"970*RPM\"+OR+\"975*RPM\"+OR+\"980*RPM\"+OR+\"985*RPM\"+OR+\"990*RPM\"+OR+\"995*RPM\"+OR+\"1000*RPM\"+OR+\"1005*RPM\"+OR+\"1010*RPM\"+OR+\"1015*RPM\"+OR+\"1020*RPM\"+OR+\"1025*RPM\"+OR+\"1030*RPM\"+OR+\"1035*RPM\"+OR+\"1040*RPM\"+OR+\"1045*RPM\"+OR+\"1050*RPM\"+OR+\"1055*RPM\"+OR+\"1060*RPM\"+OR+\"1065*RPM\"+OR+\"1070*RPM\"+OR+\"1075*RPM\"+OR+\"1080*RPM\"+OR+\"1085*RPM\"+OR+\"1090*RPM\"+OR+\"1095*RPM\"+OR+\"1100*RPM\"+OR+\"1105*RPM\"+OR+\"1110*RPM\"+OR+\"1115*RPM\"+OR+\"1120*RPM\"+OR+\"1125*RPM\"+OR+\"1130*RPM\"+OR+\"1135*RPM\"+OR+\"1140*RPM\"+OR+\"1145*RPM\"+OR+\"1150*RPM\"+OR+\"1155*RPM\"+OR+\"1160*RPM\"+OR+\"1165*RPM\"+OR+\"1170*RPM\"+OR+\"1175*RPM\"+OR+\"1180*RPM\"+OR+\"1185*RPM\"+OR+\"1190*RPM\"+OR+\"1195*RPM\"+OR+\"1200*RPM\"";break;
    case "1600-1800": var strRPMterm = "+\"1600*RPM\"+OR+\"1605*RPM\"+OR+\"1610*RPM\"+OR+\"1615*RPM\"+OR+\"1620*RPM\"+OR+\"1625*RPM\"+OR+\"1630*RPM\"+OR+\"1635*RPM\"+OR+\"1640*RPM\"+OR+\"1645*RPM\"+OR+\"1650*RPM\"+OR+\"1655*RPM\"+OR+\"1660*RPM\"+OR+\"1665*RPM\"+OR+\"1670*RPM\"+OR+\"1675*RPM\"+OR+\"1680*RPM\"+OR+\"1685*RPM\"+OR+\"1690*RPM\"+OR+\"1695*RPM\"+OR+\"1700*RPM\"+OR+\"1705*RPM\"+OR+\"1710*RPM\"+OR+\"1715*RPM\"+OR+\"1720*RPM\"+OR+\"1725*RPM\"+OR+\"1730*RPM\"+OR+\"1735*RPM\"+OR+\"1740*RPM\"+OR+\"1745*RPM\"+OR+\"1750*RPM\"+OR+\"1755*RPM\"+OR+\"1760*RPM\"+OR+\"1765*RPM\"+OR+\"1770*RPM\"+OR+\"1775*RPM\"+OR+\"1780*RPM\"+OR+\"1785*RPM\"+OR+\"1790*RPM\"+OR+\"1795*RPM\"+OR+\"1800*RPM";break;
	case "3400-3600": var strRPMterm = "+\"3400*RPM\"+OR+\"3405*RPM\"+OR+\"3410*RPM\"+OR+\"3415*RPM\"+OR+\"3420*RPM\"+OR+\"3425*RPM\"+OR+\"3430*RPM\"+OR+\"3435*RPM\"+OR+\"3440*RPM\"+OR+\"3445*RPM\"+OR+\"3450*RPM\"+OR+\"3455*RPM\"+OR+\"3460*RPM\"+OR+\"3465*RPM\"+OR+\"3470*RPM\"+OR+\"3475*RPM\"+OR+\"3480*RPM\"+OR+\"3485*RPM\"+OR+\"3490*RPM\"+OR+\"3495*RPM\"+OR+\"3500*RPM\"+OR+\"3505*RPM\"+OR+\"3510*RPM\"+OR+\"3515*RPM\"+OR+\"3520*RPM\"+OR+\"3525*RPM\"+OR+\"3530*RPM\"+OR+\"3535*RPM\"+OR+\"3540*RPM\"+OR+\"3545*RPM\"+OR+\"3550*RPM\"+OR+\"3555*RPM\"+OR+\"3560*RPM\"+OR+\"3565*RPM\"+OR+\"3570*RPM\"+OR+\"3575*RPM\"+OR+\"3580*RPM\"+OR+\"3585*RPM\"+OR+\"3590*RPM\"+OR+\"3595*RPM\"+OR+\"3600*RPM\"";break;

    default: var strRPMterm = ""; break;      
  }
  
  
  switch(strFrame) {
    case "blank":
    	var strFrameterm = "";  
      	break;
    case "56":
    	var strFrameterm = "+OR+56*+OR+\"56*\"+OR+\"56 *\"";
        break;
    case "143-5T":
    	var strFrameterm = "+143T*+OR+145T*+OR+\"143 T*\"+OR+\"145 T*\"";
        break;
    case "182-4T":
    	var strFrameterm = "+182T*+OR+184T*+OR+\"182 T*\"+OR+\"184 T*\"";  
      	break;
    case "213-5T":
    	var strFrameterm = "+213T*+OR+215T*+OR+\"213 T*\"+OR+\"215 T*\"";  
      	break;
    case "254-6T":
    	var strFrameterm = "+254T*+OR+256T*+OR+\"254 T*\"+OR+\"256 T*\"";  
      	break;
    case "284-6T":
      	var strFrameterm = "+284T*+OR+286T*+OR+\"284 T*\"+OR+\"286 T*\"";  
      	break;
    case "324-6T":
    	var strFrameterm = "+324T*+OR+326T*+OR+\"324 T*\"+OR+\"326 T*\"";  
      	break;
    case "364-5T":
    	var strFrameterm = "+364T*+OR+365T*+OR+\"364 T*\"+OR+\"365 T*\"";  
      	break;
    case "404-5T":
    	var strFrameterm = "+404T*+OR+405T*+OR+\"404 T*\"+OR+\"405 T*\"";  
      	break;      
    case "444-5T":
    	var strFrameterm = "+444T*+OR+445T*+OR+\"444 T*\"+OR+\"445 T*\"";  
      	break;      
    case "447T":
    	var strFrameterm = "+447T*+OR+\"447 T*\"";  
      	break;
    case "449T":
    	var strFrameterm = "+449T*+OR+\"449 T*\"";  
      	break;
      case "80":
    	var strFrameterm = "+\"" + strFrame + " frame\"";  
      	break;
      case "63":
    	var strFrameterm = "+\"" + strFrame + " frame\"";  
      	break;
      case "71":
    	var strFrameterm = "+\"" + strFrame + " frame\"";  
      	break;
    default:
        var strFrameterm = "+" + strFrame;
      	break;
  }   
    
      
  switch(strEnclosure) {
    case "blank":
    	var strEnclosureterm = "";
      	break;
    case "TEC":
    	var strEnclosureterm = "+TEFC+OR+TEWD+OR+TEAO+OR+TENV";  
      	break;
    default:
        var strEnclosureterm = "+" + strEnclosure;
        break;
  }
  
  switch(strVoltage) {
    case "blank":
    	var strVoltageterm = "";
      	break;
    default:
        var strVoltageterm = "+" + strVoltage;
        break;
  }

  
//var strsearch = "https://www.bmebearings.com/search?q=" + strHpterm + strRPMterm + strVoltageterm + strEnclosureterm + strEnclosureterm;
var strsearch = "https://www.bmebearings.com/search?q=-finder+motor" + strHpterm + strFrameterm + strEnclosureterm + strVoltageterm + strRPMterm + "&view=motorfinder";
//Get postdata to the url
  var a = document.getElementById("hp").selectedIndex + "-" + document.getElementById("rpm").selectedIndex + "-" + document.getElementById("frame").selectedIndex + "-" + document.getElementById("voltage").selectedIndex + "-" + document.getElementById("enclosure").selectedIndex;
  
  
  //Search with the generated url with postdata
  window.location.href =strsearch + "&" + a;
}

function urlparse() {
  document.title = "Electric Motor Finder - BME Bearings and Surplus";
       var queryString = window.location.search;
       queries = queryString.split("&");
  	   if (typeof(queries[3]) == 'undefined') {indexes = queries[2].split("-");} 
       else {indexes = queries[3].split("-");}  
  	document.getElementById("hp").selectedIndex = indexes[0];
	document.getElementById("rpm").selectedIndex = indexes[1];
	document.getElementById("frame").selectedIndex = indexes[2];
	document.getElementById("voltage").selectedIndex = indexes[3];
	document.getElementById("enclosure").selectedIndex = indexes[4];  		
    }

